import React, { useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import BrokenImageIcon from "@mui/icons-material/BrokenImage";

function LazyImage({ src, alt, className, wrapperClassName, sx, wrapperSx, spinnerSx, ...imgProps }) {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    const handleLoad = async (event) => {
        try {
            if (event?.target?.decode) {
                await event.target.decode();
            }
        } catch (_) {
            // Rendering the loaded image is still preferable if decode fails.
        }

        setLoaded(true);
        imgProps.onLoad?.(event);
    };

    return (
        <Box
            component="span"
            className={wrapperClassName}
            sx={{
                position: "relative",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "visible",
                ...wrapperSx
            }}
        >
            {!loaded && !error && (
                <Box
                    component="span"
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "grid",
                        placeItems: "center",
                        zIndex: 1,
                        ...spinnerSx
                    }}
                >
                    <CircularProgress size={24} thickness={5} sx={{ color: "#0e2b4d" }} />
                </Box>
            )}

            <Box
                component="img"
                src={src}
                alt={alt}
                className={className}
                loading="lazy"
                {...imgProps}
                onLoad={handleLoad}
                onError={(event) => {
                    setError(true);
                    imgProps.onError?.(event);
                }}
                sx={{
                    position: "static",
                    display: "block",
                    opacity: loaded && !error ? 1 : 0,
                    transition: "opacity .25s ease",
                    ...sx
                }}
            />

            {error && (
                <Box
                    component="span"
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "grid",
                        placeItems: "center",
                        color: "text.disabled",
                        zIndex: 2
                    }}
                >
                    <BrokenImageIcon />
                </Box>
            )}
        </Box>
    );
}

export default LazyImage;
